import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";


const Lfa = () => {
  const headers = ['LFA'];

  useEffect(() => {


  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>LFA </h1>
        <h3>Spot the Fake. Safeguard the Cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              LFA
            </div>

            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Method_Description', 'Protocol', 'Discussion', 'References']}
              currentClassName="active">

              <li><a href="#Method_Description">Method Description</a></li>
              <li><a href="#Protocol">Protocol</a></li>
              <li><a href="#Discussion">Discussion</a></li>
              <li><a href="#References">References</a></li>

            </Scrollspy>
          

            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-holding-flask-3-1.webp"
              alt="Mascot is holding flask"
            />

          </div>

        </div>
        <div className="main_lab_style">
          <WindowBrowser description={
            <>
              <div style={{ display: 'none' }}>
                {
                  headers.map(header => {
                    return (
                      <section href={header.split(' ')[0]}>{
                        header
                      }</section>
                    )

                  })
                }
              </div>

              <section id="Method_Description">
                <h1>Method Description</h1>
                <p>
                  The Lateral Flow Assay (LFA) is a point-of-care diagnostic method designed for the rapid detection of target analytes in a variety of samples, utilizing capillary flow to move a liquid sample across a series of pads and membranes. In this assay, aptamers, which are short single-stranded DNA or RNA molecules, replace traditional antibodies as the recognition element due to their high specificity and stability. The LFA strip is composed of a sample pad, conjugate pad with gold nanoparticle (AuNP)-aptamer conjugates, a nitrocellulose membrane containing test and control lines, and an absorbent pad to facilitate capillary action. When a sample containing Bevacizumab is applied, it competes with the labeled AuNP-aptamer conjugate at the test line, generating a colorimetric signal inversely proportional to the concentration of the target analyte. This competitive format provides a simple and effective means of detecting Bevacizumab, with results visible within minutes, making LFA a reliable tool for rapid testing and an ideal method for the detection of counterfeit Bevacizumab.
                </p>
              </section>
              <section id="Protocol">
                <h1> Protocol</h1>
                <p>
                  The LFA test strip preparation begins with the preparation of biotin-labeled aptamers for conjugation with streptavidin to facilitate efficient binding to the nitrocellulose membrane. First, prepare a solution of biotin-labeled aptamer (5′-Biotin-CGC CAA CCA CCA TCA ATG CCA GCG-3′) in 50 mM PBS with 1 mM EDTA, pH 8.5, at a final concentration of 10 μM [1]. Heat the aptamer solution at 75°C for 5 minutes to denature it, then allow it to cool on ice for 10 minutes to facilitate proper folding [2]. Add streptavidin to the aptamer solution in a 1:1.5 molar ratio (streptavidin) and incubate at room temperature for 30 minutes to allow complete biotin-streptavidin interaction [3]. To separate poorly bound aptamers, transfer the conjugate mixture into a Centricon filter with a molecular weight cutoff of 10 kDa and centrifuge at 4,000 x g for 10-15 minutes, allowing unbound aptamers to pass through the filter while retaining the conjugated streptavidin-aptamer complex [4]. Collect the retentate, dilute it to the desired concentration, and dispense 100 μL of the biotin-streptavidin-aptamer conjugate onto the nitrocellulose membrane using a dispensing system, applying it to create both the test line and control line on each LFA strip [1]. Coat each LFA strip with 200 μL of 5% (w/v) BSA in PBS to block non-specific binding sites, incubating for 2 hours at room temperature [2]. After incubation, wash each strip three times with 200 μL PBST (PBS + 0.05% Tween 20), shaking for 30 seconds with each wash [3]. Prepare aptamer-conjugated gold nanoparticles (AuNPs) by conjugating AuNPs (20-50 nm diameter) with the aptamer (5′-GCG GTT GGT GGT AGT TAC GGT CGC AAA AAA AAA AAA AAA AAA-SH-3′) to form the AuNP-aptamer conjugate, mixing with 1.5 μL of blocking buffer (1/5 dilution of Casein) to stabilize and prevent aggregation, and dispense 100 μL of the AuNP-aptamer conjugate onto the conjugate pad, letting it dry at room temperature [1]. Assemble the complete LFA strip by placing the sample pad, conjugate pad, nitrocellulose membrane, and absorbent pad onto a backing card, ensuring alignment, and allow the assembled strips to dry completely at room temperature [2]. Apply 200 μL of PBS or BBS (0.5% surfactant, e.g., Tween 20) to the conjugate pad as a running buffer and dispense 100 μL of the Bevacizumab sample (prepared in PBS containing 0.1% (w/v) BSA) onto the sample pad, allowing it to migrate across the membrane [3].  A single line (control line only - 5′-Biotin-TTT TTT TTT TTT TTT TTT-3′) indicates the presence of Bevacizumab, whereas two lines (control and test lines) indicate Bevacizumab is absent [2]. Finally, optimize the signal-to-noise ratio by adjusting the concentration of blocking buffer and surfactants as needed, and store the LFA strips in a cool, dry place to maintain stability and ensure reliable performance [3].
                </p>
              </section>



              <section id="Discussion">
                <h1>Discussion</h1>
                <p>
                  In the ongoing optimization and testing of our LFA test for detecting Bevacizumab, we have identified that the working amount of aptamer CU2#19 is within the range of 0.5 to 20 ng per test strip. This range provides sufficient binding capability for Bevacizumab detection while maintaining a clear and distinguishable signal. Although we are still refining the exact aptamer quantity to achieve optimal sensitivity and minimize background noise, our preliminary results indicate that the LFA test is functioning effectively. The current setup successfully detects the presence of Bevacizumab in samples, validating the potential of CU2#19 in a competitive LFA format. The challenge remains to further fine-tune the aptamer concentration to maximize the test's sensitivity and reliability, but the initial success demonstrates that the test is already operational and reliable for point-of-care applications.
                </p>
              </section>


              <section id="References">
                <p>
                  <h1> References </h1>
                </p>
                <ol>
                  <li>
                    Ellington, A. & Szostak, J. In vitro selection of RNA molecules that bind specific ligands. Nature 346, 818–822 (1990).                  </li>
                  <li>
                    Saito, T., Kobayashi, K. & Nakamura, M. Development of a DNA aptamer that binds to the complementarity-determining region of therapeutic monoclonal antibody and affinity improvement induced by pH-change for sensitive detection. Biosens. Bioelectron. 203, 114027 (2022).

                  </li>
                  <li>
                    Ahirwar, R., Nahar, S., Aggarwal, S. & Ramawat, N. In silico selection of an aptamer to estrogen receptor alpha using computational docking employing estrogen response elements as aptamer-alike molecules. Sci. Rep. 6, 21285 (2016).
                  </li>
                  <li>
                    Toh, S. Y., Citartan, M., Gopinath, S. C. B. & Tang, T.-H. Aptamers as a replacement for antibodies in enzyme-linked immunosorbent assay. Biosens. Bioelectron. 64, 392–403 (2015).

                  </li>
                </ol>
                <br></br>
                <br></br>
                <br></br>
                <br></br>


              </section>
            </>
          } />
        </div>
      </section>
    </div>
  );
}

export default Lfa;
